import { header } from "./header";
import { factory_map } from "./factory-map";

jQuery(document).on("ready", () => {

    let headerSettings = new header;
    let factoryMap = new factory_map;
});

